import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import i18next from 'i18next';
import { getRouteByName } from 'app/routes';
import { useField } from 'formik';
import { generatePath, Link } from 'react-router-dom';

const gqlGetVehicles = gql`
  query getVehicles($where: String, $offset: Int, $limit: Int, $order: String) {
    getVehicles(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: plateNumber
      }
      recordCount
    }
  }
`;

type Props = { collectorId?: number } & FsProps;

export const FieldSelectVehicle = ({
  label = i18next.t('Όχημα'),
  name = 'vehicleId',
  defaultValues = {},
  collectorId = null,
  ...rest
}: Props) => {
  function useGetDriversLazyQuery() {
    return useLazyQuery(gqlGetVehicles, { fetchPolicy: 'no-cache' });
    //return [null, { loading: null, data: null }];
  }
  const [field, { value }] = useField(name);
  const path = value ? generatePath(getRouteByName('Vehicle'), { id: value }) : null;

  const showLabel = value && path ? <Link to={path}>{label}</Link> : label;

  return (
    <FieldSelectDB
      {...rest}
      label={showLabel}
      name={name}
      where={collectorId ? JSON.stringify({ collectorId: collectorId }) : JSON.stringify({})}
      // @ts-ignore
      sbLabel={defaultValues?.vehPlateNumber ?? undefined}
      hook={useGetDriversLazyQuery}
    />
  );
};

